import React, { useState, useEffect } from 'react';
import { Play, Loader } from '../icons';
import { getWeddingVideos } from '../services/api';
import { useLanguage } from '../context/LanguageContext';

function WeddingVideos() {
  const { t } = useLanguage();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    getWeddingVideos()
      .then(res => setVideos(res.data.videos || []))
      .catch(() => setFailed(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#fdf2f8', paddingTop: '100px', paddingBottom: '60px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a2e', marginBottom: '10px' }}>
            {t('weddingVideos.title')}
          </h1>
          <p style={{ color: '#666', fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto' }}>
            {t('weddingVideos.subtitle')}
          </p>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '100px 0' }}>
            <Loader size={40} className="spin" style={{ color: '#e91e63' }} />
          </div>
        ) : videos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 20px', background: '#fff', borderRadius: '16px' }}>
            <Play size={48} style={{ color: '#ccc', marginBottom: '16px' }} />
            <p style={{ color: '#999', fontSize: '1.1rem' }}>{failed ? t('weddingVideos.loadFailed') : t('weddingVideos.empty')}</p>
          </div>
        ) : (
          <>
            {/* Active video player */}
            {activeVideo && (
              <div style={{ marginBottom: '40px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 30px rgba(0,0,0,0.12)', background: '#000' }}>
                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${activeVideo.videoId}?autoplay=1`}
                    title={activeVideo.title}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div style={{ padding: '16px 20px', background: '#1a1a2e' }}>
                  <h3 style={{ color: '#fff', fontSize: '1.1rem', margin: 0 }}>{activeVideo.title}</h3>
                  {activeVideo.channelTitle && (
                    <p style={{ color: '#aaa', fontSize: '0.9rem', marginTop: '4px' }}>{activeVideo.channelTitle}</p>
                  )}
                </div>
              </div>
            )}

            {/* Video grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: '24px'
            }}>
              {videos.map((video) => (
                <div
                  key={video.videoId}
                  onClick={() => setActiveVideo(video)}
                  style={{
                    background: '#fff',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    border: activeVideo?.videoId === video.videoId ? '2px solid #e91e63' : '2px solid transparent'
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)'; }}
                >
                  <div style={{ position: 'relative' }}>
                    <img
                      src={video.thumbnail || `https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg`}
                      alt={video.title}
                      style={{ width: '100%', height: '180px', objectFit: 'cover', display: 'block' }}
                    />
                    <div style={{
                      position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                      width: '50px', height: '50px', borderRadius: '50%', background: 'rgba(233,30,99,0.9)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                      <Play size={24} fill="#fff" color="#fff" />
                    </div>
                  </div>
                  <div style={{ padding: '14px 16px' }}>
                    <h3 style={{
                      fontSize: '0.95rem', fontWeight: 600, color: '#1a1a2e', margin: 0,
                      overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box',
                      WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', lineHeight: '1.4'
                    }}>
                      {video.title}
                    </h3>
                    {video.channelTitle && (
                      <p style={{ color: '#888', fontSize: '0.8rem', marginTop: '6px', marginBottom: 0 }}>
                        {video.channelTitle}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default WeddingVideos;
